import { useState, useCallback } from 'react';

const DEFAULT_LIMIT = 20;

export function usePagination(initialLimit = DEFAULT_LIMIT) {
  const [page, setPage] = useState(1);
  const [limit] = useState(initialLimit);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const applyPaginationMeta = useCallback((meta) => {
    if (!meta) return;
    setTotal(meta.total ?? 0);
    setTotalPages(meta.totalPages ?? 1);
    if (meta.page) setPage(meta.page);
  }, []);

  const resetPage = useCallback(() => setPage(1), []);

  const paginationProps = {
    page,
    limit,
    total,
    totalPages,
    onPageChange: setPage,
    loading,
  };

  return {
    page,
    limit,
    total,
    totalPages,
    loading,
    setLoading,
    setPage,
    resetPage,
    applyPaginationMeta,
    paginationProps,
  };
}
